// extracted by mini-css-extract-plugin
export default {"backgroundIcon":"Document_backgroundIcon__72ZE4","bzObjTypeHeading":"Document_bzObjTypeHeading__7bfod"};